/*
 * Copyright (c) 2023.
 * Kevin <tranthaidnvn@gmail.com>
 */
import axios from "axios";
import { AppRouter, RouterName } from "core/router";
import store from "core/store/store";
import { deviceStorage } from "core/utils/devicestorage";
import { expireToken as expireTokenClient } from "modules/Auth/store/actions";
import queryString from "query-string";
import uuid from "react-uuid";
import { config } from "../config/app";
import { requestUpgrade } from "../store/actions";

const appPackage = config.appPackage;
const BaseAPI = config.apiUrl;
const VERSION = config.version;

export const initApplication = (): void => {
  if (
    !localStorage.getItem("storage_driver") ||
    localStorage.getItem("storage_driver") !== config.appStorage
  ) {
    //console.log(deviceStorage[config.appStorage])
    deviceStorage[config.appStorage].flush();
    localStorage.setItem("storage_driver", config.appStorage);
  }
};

export const settingApplication = () => {
  deviceStorage[config.appStorage].setItem(
    appPackage + "_CLIENT_UUID",
    (window as any)._APP_DEVICE_KEY || uuid()
  );
  deviceStorage[config.appStorage].setItem(
    appPackage + "_CLIENT_VERSION",
    VERSION
  );
  deviceStorage[config.appStorage].setItem(
    appPackage + "_APP-PLATFORM",
    (window as any)._APP_PLATFORM || "Android"
  );

  //TODO: NATIVE APP SET VALUE
  deviceStorage[config.appStorage].setItem(
    appPackage + "_DEVICE-AGENT",
    (window as any)._APP_AGENT || ""
  );
  deviceStorage[config.appStorage].setItem(
    appPackage + "_APP-VERSION",
    (window as any)._APP_NATIVE_VERSION || "1.0.0"
  );
  deviceStorage[config.appStorage].setItem(
    appPackage + "_APP-DEVICE-KEY",
    (window as any)._APP_DEVICE_KEY || uuid()
  );
  deviceStorage[config.appStorage].setItem(
    appPackage + "_FCM_TOKEN",
    (window as any)._APP_FCM_TOKEN || "FCM_TOKEN_1"
  );

  deviceStorage[config.appStorage].setItem(
    appPackage + "_APP-LOC",
    (window as any)._APP_LOC || "VN"
  );

  deviceStorage[config.appStorage].setItem(
    appPackage + "_APP-LANG",
    (window as any)._APP_LANG || "vi"
  );
  deviceStorage[config.appStorage].setItem(
    appPackage + "_APP-TYPE",
    (window as any)._APP_TYPE || "USER"
  );
  if (
    deviceStorage[config.appStorage].getItem(appPackage + "_CLIENT_VERSION") &&
    deviceStorage[config.appStorage].getItem(appPackage + "_CLIENT_VERSION") !==
      config.webviewVersion
  ) {
    deviceStorage[config.appStorage].setItem(
      appPackage + "_CLIENT_VERSION",
      config.webviewVersion
    );
    // (window as any).webViewRequestClearCache();
  }

  if (
    !localStorage.getItem("request_permission_version") ||
    localStorage.getItem("request_permission_version") != config.webviewVersion
  ) {
    localStorage.setItem("request_permission_version", config.webviewVersion);
    // (window as any).webViewRequestPermission([
    //   "camera",
    //   "library",
    //   "notification",
    //   "location",
    // ]);
  }
};

export const setupAxios = () => {
  // axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common["Authorization"] = `Bearer ${deviceStorage[
    config.appStorage
  ].getItem(config.appPackage + "_X_TOKEN")}`;
  // axios.defaults.headers.common['X-UUID'] = deviceStorage[config.appStorage].getItem(appPackage+'_CLIENT_UUID')
  // axios.defaults.headers.common['X-VERSION'] = deviceStorage[config.appStorage].getItem(appPackage+'_CLIENT_VERSION')
  //TODO: Nhớ fix cái chỗ platform sau khi sửa api
  axios.defaults.headers.common["APP-PLATFORM"] =
    deviceStorage[config.appStorage].getItem(appPackage + "_APP-PLATFORM") ||
    "Android";
  axios.defaults.headers.common["APP-VERSION"] =
    deviceStorage[config.appStorage].getItem(appPackage + "_APP-VERSION") ||
    "1.0.0";
  axios.defaults.headers.common["DEVICE-AGENT"] = deviceStorage[
    config.appStorage
  ].getItem(appPackage + "_DEVICE-AGENT");
  axios.defaults.headers.common["WEBVIEW-KEY"] = deviceStorage[
    config.appStorage
  ].getItem(appPackage + "_CLIENT_UUID");
  axios.defaults.headers.common["WEBVIEW-VERSION"] = deviceStorage[
    config.appStorage
  ].getItem(appPackage + "_CLIENT_VERSION");
  axios.defaults.headers.common["DEVICE-KEY"] = deviceStorage[
    config.appStorage
  ].getItem(appPackage + "_APP-DEVICE-KEY");

  axios.defaults.headers.common["FCM-TOKEN"] = deviceStorage[
    config.appStorage
  ].getItem(appPackage + "_FCM_TOKEN");
  // axios.defaults.headers.common['WEBPUSH-TOKEN'] = deviceStorage[config.appStorage].getItem(appPackage+'_WEBPUSH_TOKEN')
  axios.defaults.headers.common["APP-LOC"] = deviceStorage[
    config.appStorage
  ].getItem(appPackage + "_APP-LOC");
  // axios.defaults.headers.common['APP-LOC'] = 'VN'
  axios.defaults.headers.common["APP-LANG"] = deviceStorage[
    config.appStorage
  ].getItem(appPackage + "_APP-LANG");
  // axios.defaults.headers.common['APP-LANG'] = 'vi'

  axios.defaults.headers.common["APP-TYPE"] = deviceStorage[
    config.appStorage
  ].getItem(appPackage + "_APP-TYPE");


  axios.interceptors.response.use(
    (res) => {
      // Add configurations here
      return res;
    },
    (err) => {
      console.log("err interceptors", err?.response);
      
      // if(err?.response?.status == 401) {
      //     //console.log(401);
      //
      //     deviceStorage[config.appStorage].removeItem(appPackage+'_X_TOKEN')
      //
      //     if (window.location.pathname.startsWith(BASENAME.CLIENT)) {
      //         store.dispatch(expireTokenClient({}));
      //     }else{
      //         store.dispatch(expireTokenMerchant({}));
      //     }
      //     // store.dispatch(logout())
      //     // setTimeout(()=> AppRouter.navigate(RouterName.LOGIN), 1000)
      // }
      if (err?.response?.status == 426) {
        const url =
          deviceStorage[config.appStorage]
            .getItem(appPackage + "_APP-PLATFORM")
            .toLowerCase() + "_market_url";
        console.error(
          426,
          "426 Upgrade Required",
          err.response.data?.errors?.[url] || 'url',
          url
        );
        // @ts-ignore
        window.webViewRequestTerminateSplash();
        store.dispatch(requestUpgrade(err.response.data?.errors?.[url] || "url"));
      }
      if (err?.response?.status == 401) {
        store.dispatch(expireTokenClient({}));
        removeAxiosToken(true);
      }
      return Promise.reject(err);
    }
  );
};

export const setAxiosToken = (token: string) => {
  //console.log('setAxiosToken', token);

  axios.defaults.headers.common.Authorization = "Bearer " + token;
  // setupAxios()
};

export const removeAxiosToken = (keepLink?:any) => {
  deviceStorage[config.appStorage].removeItem(config.appPackage + "_X_TOKEN");
  axios.defaults.headers.common.Authorization = "";
  if(!keepLink){
    const isOnBoarded = localStorage.getItem("recipe_onBoarded");
    if(isOnBoarded !== 'true') {
      AppRouter.navigate(RouterName.ONBOARDING)
      return
    }
    AppRouter.navigate(RouterName.MAIN);
  }
};

const API = {
  post: (url: string, data: any) => axios.post(BaseAPI + url, data),
  delete: (url: string, data: any) => axios.delete(BaseAPI + url, data),
  patch: (url: string, data: any) => axios.patch(BaseAPI + url, data),
  put: (url: string, data: any) => axios.put(BaseAPI + url, data),
  get: (url: string, params: any, option: any = {}) => {
    const query_string = queryString.stringify(params);
    const _url =
      option && option.extenal
        ? url + "?" + query_string
        : BaseAPI + url + "?" + query_string;
    return axios.get(_url, option);
  },
  upload: (url: string, data: any, option: any) =>
    axios.post(BaseAPI + url, data, option),
  deleteFile: (url: string, data: any, option: any) =>
    axios.post(BaseAPI + url, data, option),
};

export default API;
